import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from '../../core/settings.service';
import {Cookie} from '../../helper/cookie';
import {Store} from '@ngrx/store';
import * as fromUser from '../../user/store/user.reducers';

@Injectable({
  providedIn: 'root'
})
export class TrialService {

  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService,
    private cookie: Cookie,
    private store: Store<fromUser.State>
  ) { }

  addTrialAudit(profile: string, userUid: string) {
    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'report/trial/add',
      {
        profile: profile,
        user_uid: userUid
      }
    );
  }
}
